import { default as indexgw2ikJsyhcMeta } from "/usr/src/app/pages/index.vue?macro=true";
import { default as support3WkxXVdKUmMeta } from "/usr/src/app/pages/support.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/usr/src/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "support",
    path: "/support",
    component: () => import("/usr/src/app/pages/support.vue").then(m => m.default || m)
  }
]